/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';
import PATHS from '../../../routes/urls';
import AdminNavBarItem from '../super-admin/AdminNavBarItem';

const span13 = (tabName) => (
  <span className="text-uppercase" style={{ fontSize: '14px' }}>
    {tabName}
  </span>
);
const groupIcon = 'https://res.cloudinary.com/tizeti/image/upload/v1542971013/Group-3.png';

const VpFiberSideBar = () => {
  return (
    <div className="s-layout__sidebar">
      <Link className="s-sidebar__trigger" to="#">
        <i className="fa fa-bars mr-3" />
      </Link>

      <nav className="s-sidebar__nav">
        <div className="">
          <Link className="navbar-brand-logo" to="/vpfiber-overview">
            <img src="https://res.cloudinary.com/tizeti/image/upload/v1542971047/Tizeti-Logo.png" alt="homepage" />
          </Link>

          <ul className="">
            <div className="">
              <AdminNavBarItem url="/vpfiber-overview" name={span13('Overview')} src={groupIcon} target="_self" />

              <AdminNavBarItem
                          url={PATHS. NEW_PRODUCTS_OVERVIEW}
                          name={span13('HOTSPOT')}
                          src={groupIcon}
                          target="_blank"
                        />

                <AdminNavBarItem
                          url={PATHS. ASSET_TEAM_CLOSED_LEADS}
                          name={span13('QA')}
                          src={groupIcon}
                          target="_blank"
                        />

                        <AdminNavBarItem
                          url="/fibre-team"
                          name={span13('FIBER')}
                          src={groupIcon}
                          target="_blank"
                        />
                
            </div>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default VpFiberSideBar;
